import { useMemo } from "react";
import { useIntl } from "react-intl";
import type { UserRoles } from "~enums/userRoles";
import { userRolesConfig } from "../constants/userRolesConfig";
import { PermissionProducts } from "../enums/permissionProducts";

const useGetUserRoleSelectOptionsByProduct = () => {
  const { formatMessage } = useIntl();

  return useMemo(() => {
    const result: Record<PermissionProducts, { value: UserRoles; label: string }[]> = {
      [PermissionProducts.Competitions]: [],
      [PermissionProducts.TeamManager]: [],
    };

    for (const [userRole, roleConfig] of Object.entries(userRolesConfig)) {
      result[roleConfig.product].push({
        value: userRole as UserRoles,
        label: formatMessage({ id: `permissions.userRole.${userRole}` }),
      });
    }

    return result;
  }, [formatMessage]);
};

export default useGetUserRoleSelectOptionsByProduct;
